<template>
	<v-dialog
		transition="dialog-transition"
		max-width="500"
		:value="innerValue"
		@click:outside="innerValue = false;"
	>
		<v-card>
			<v-card-text class="pa-4">
				<v-form v-model="valid">
					<v-row class="text-center" dense>
						<v-col cols="12">
							<v-text-field
								v-model="email"
								:label="emailOrUsernameLabel"
								:rules="[rules.required, rules.emailOrUsername]"
								@keydown.enter="login"
							></v-text-field>
						</v-col>

						<v-col cols="12">
							<v-text-field
								v-model="password"
								label="كلمة المرور"
								:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
								:type="showPassword ? 'text' : 'password'"
								:rules="[rules.required, rules.password]"
								@click:append="() => (showPassword = !showPassword)"
								@keydown.enter="login"
							></v-text-field>
						</v-col>

						<v-col v-if="showLoginError" cols="12">
							<v-alert type="error" :value="true">
								{{ errorMessage }}
							</v-alert>
						</v-col>

						<v-col cols="12">
							<v-btn
								color="primary"
								class="text-none mx-1"
								:disabled="!valid"
								:loading="loading"
								@click="login"
							>
								تسجيل الدخول
							</v-btn>

							<v-btn
								color="primary"
								class="text-none mx-1"
								:loading="loading"
								to="signup"
								text
								@click="innerValue = false"
							>
								انشاء حساب جديد
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import client from "@/client";
import rulesMixin from "@/mixins/rules-mixin";

export default {
	mixins: [rulesMixin],
	props: {
		value: {
			type: Boolean
		}
	},
	data() {
		return {
			valid: false,
			email: null,
			password: null,
			showPassword: false,
			showLoginError: false,
			errorMessage: "اسم المستخدم أو كلمة المرور خاطئة",
			loading: false
		};
	},
	computed: {
		isEmailOrUsername() {
			if (this.email == null || this.email == "") {
				return "both";
			} else if (this.email.indexOf("@") != -1) {
				return "email";
			} else {
				return "username";
			}
		},
		emailOrUsernameLabel() {
			if (this.isEmailOrUsername == "email") {
				return "البريد الإلكتروني";
			} else if (this.isEmailOrUsername == "username") {
				return "اسم المستخدم";
			} else {
				return "البريد الإلكتروني / اسم المستخدم";
			}
		},
		innerValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	methods: {
		login() {
			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			let data = new FormData();

			if (this.isEmailOrUsername == "email") {
				data.append("email", this.email);
			} else if (this.isEmailOrUsername == "username") {
				data.append("displayName", this.email);
			}
			data.append("password", this.password);

			this.loading = true;
			this.showLoginError = false;
			client
				.post("/api/users/login", data, config)
				.then(response => {
					// console.log(response);
					this.loading = false;
					this.$store.dispatch("setToken", "bearer " + response.data.data);
					this.innerValue = false;
				})
				.catch(err => {
					console.log(err);

					if (err.response.data.message == "User does not exists") {
						this.errorMessage = "اسم المستخدم غير موجود";
					} else if (err.response.data.message == "Invalid Email/Username or Password") {
						this.errorMessage = "اسم المستخدم أو كلمة المرور خاطئة";
					} else {
						this.errorMessage = "اسم المستخدم أو كلمة المرور خاطئة";
					}
					
					this.loading = false;
					this.showLoginError = true;
				});
		}
	}
};
</script>